import { colors } from '../../Colors/colors'

export const pluginsTheme = {
   light: {
      pluginsHeader: {
         headerNameColor: 'text-gray-900',
         headerContainer: 'bg-base-white border-gray-200'
      },
      pluginsList: {
         bgColor: 'bg-gray-100',
         listBorderColor: 'border-gray-300',
         pluginTitleColor: 'text-gray-700',
         pluginDescriptionColor: 'text-gray-700',
         dotsIconColor: colors['gray-700'],
         popoverOptionsColor: 'text-gray-900',
         popoverContainerHoverBackgroundColor: 'hover:bg-gray-50'
      }
   },
   dark: {}
}
